module.exports = __webpack_public_path__ + "media/images/logos/yogasix-logo-c703e7c6f3a4a643cb4f8ee1f6f0730e.png";